export default "__VITE_ASSET__8e150c72__"